import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { LANGUAGE_MAPPINGS } from '../../constants/language-mappings.const';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GlobalConstants } from '../../constants/global.constant';
import { CommonService } from '../../services/common.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { Utils } from '../../../common/utils/utils';
import { SelectLanguageConstants } from '../select-lang/constants/select-lang.consts';
import { OemConstants } from '../../../../app/core/routing/services/oem/constants/oem.constants';
import { RouterConstants } from '../../../../app/core/routing/constants/app-paths.constant';
import { Router } from '@angular/router';

@Component({
  selector: 'iposcen-lang-multi-select',
  templateUrl: './lang-multi-select.component.html',
  styleUrls: ['./lang-multi-select.component.scss']
})
export class LangMultiSelectComponent implements OnInit {

  @Input() selectedItem: any[];
  @Input() isInEdit = false;
  @Input() selectedLang = [];
  @Output() readonly updateLanguage = new EventEmitter<object>();
  @Output() readonly updateLanguageChrome = new EventEmitter<object>();
  @ViewChild('profileLanguageModal') modalContent: TemplateRef<LangMultiSelectComponent>;
  @Input() isPartnerContent: boolean;
  @Input() isPopupOpenAuto: boolean;
  @Input() systemIdSelectedLang: any[];
  @Input() isDuplicate = false;
  languageJSON = [];
  userSelectedLanguage = [];
  userPrtnerSelectedLang = new Map();
  RecoverPrtnerSelectedLang = new Map();
  allLang: boolean = true;
  newSelectedLanguage = [];
  userSelectedLanguageName = [];
  browserLanguage: string;
  langForm: FormGroup;
  selectedLangvalues: {};
  direction: string;
  isChromeSelected: false;
  languageLabel = SelectLanguageConstants.LANGUAGE_HEADING;
  allLanguagesLabel = SelectLanguageConstants.ALL_LANGUAGES_TEXT;
  cancelButtonText = OemConstants.cancelButton;
  noSelection: boolean;
  isProfilePage: boolean = false;
  chromeLangCode = [];
  private modalRef: NgbModalRef;
  private modalOption: NgbModalOptions = {};
  private ngUnsubscribe = new Subject<boolean>();

  constructor(private modalService: NgbModal,
    private formbuilder: FormBuilder,
    private cmnService: CommonService, private router: Router) { }

  ngOnInit(): void {
    this.noSelection = true;
    this.direction = this.cmnService.direction;
    this.newSelectedLanguage.push(GlobalConstants.LANGUAGE_ENGLISH);
    // to check  which page this component is loaded in.IIT2-1954
    let currentdetailPage = this.router.url;
    const pageName = currentdetailPage.lastIndexOf('/');
    if (currentdetailPage.substring(pageName + 1) === GlobalConstants.CREATE_PROFILE ||
      currentdetailPage.includes(RouterConstants.EDIT_PROFILE)) {
      this.isProfilePage = true;
    }
    if (!this.isProfilePage) {
      this.languageGeneration();
    }
    this.browserLanguage = '';
    this.langForm = this.formbuilder.group({
      lang: new FormControl('', [Validators.required])
    });
    //IIT2-1954
    Utils.filterChromeLanguages().forEach(element => {
      if (element.langCode === 'zh-Hant') {
        element.langCode = 'zh-tw';
      }
      this.chromeLangCode.push(element.langCode.toLocaleLowerCase());
    });
    if (!this.isProfilePage) {
      setTimeout(() => {
        this.selectedItem.forEach(ele => {
          this.updateList(ele, true);
        });
      }, 2000);
    }
    if (this.isPartnerContent) {
      if (!this.isDuplicate) {
        setTimeout(() => {
          if (this.selectedLang) {
            this.systemIdSelectedLang = this.systemIdSelectedLang.filter(data => !this.selectedLang.includes(data));
            this.systemIdSelectedLang.forEach(ele => {
              this.updateListPartnerContent(ele, true);
            });
          }
          this.systemIdSelectedLang.forEach((ele) => {
            this.userPrtnerSelectedLang.delete(ele);
          });
          if(!this.isInEdit) {
            this.userPrtnerSelectedLang = this.RecoverPrtnerSelectedLang;
          }
        }, 2000);
      }

    }
    if (this.isInEdit) {
      if (!this.isDuplicate) {
        this.selectedLang.forEach(ele => {
          let temp = this.languageJSON.filter(data => data.langCode === ele);
          this.userPrtnerSelectedLang.set(temp[0].langCode, temp[0].langName);
        })
      }
      if (!this.isDuplicate) {
        setTimeout(() => {
          this.updateLanguageList();
        }, 0);
      }
    }
    //Observer to receive OS selection in profile IIT2-1954
    this.cmnService.chromebookObser
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => {
        this.isChromeSelected = res;
        this.userSelectedLanguageName = [];
        this.userSelectedLanguage = [];
        this.languageGeneration();
        if (res) {
          this.chromeLanguageSelection();
        } else {
          this.selectedItem.forEach(ele => {
            if (ele === 'zh-Hans') ele = 'zh-cn';
            else if (ele === 'zh-Hant') ele = 'zh-tw';
            this.updateList(ele, true);
          });
        }
      });
  }

  //IIT2-1954 
  //Function to filter 14 chromebook langugages.
  chromeLanguageSelection() {
    let tempLanugageJson = [];
    this.languageJSON.forEach((data, i) => {
      if (this.chromeLangCode.includes(data.langCode.toLowerCase())) {
        tempLanugageJson.push(this.languageJSON[i]);
      }
    });
    this.languageJSON = [...tempLanugageJson];
    this.selectedItem.forEach((ele, i) => {
      if (ele === GlobalConstants.CHINESE_HANT) {
        this.selectedItem[i] = GlobalConstants.CHINESE_TW;
      }
    });
    let tempSelectedLang = this.selectedItem.filter(e => this.chromeLangCode.includes(e.toLowerCase()));
    tempSelectedLang.forEach(ele => {
      this.updateList(ele, true);
    });
    this.checkCount();
    this.selectedLangvalues = {
      userSelectedLanguageName: this.userSelectedLanguageName,
      userSelectedLanguage: tempSelectedLang
    };
    this.updateLanguageChrome.emit(this.selectedLangvalues);
  }
  languageGeneration() {
    let temp = [...this.languageJSON];
    this.languageJSON = [];
    LANGUAGE_MAPPINGS.forEach(element => {
      if (element.langCode === 'zh-Hans') {
        element.langCode = 'zh-cn';
      } else if (element.langCode === 'zh-Hant') {
        element.langCode = 'zh-tw';
      }
        const language = {
        langCode: element.langCode,
        langName: element.langInEng,
        checked: false,
        disabled: false
      };
      this.languageJSON.push(language);
    });
    //IIT2-1954
    this.languageJSON.forEach((data, i) => {

      if (this.userSelectedLanguage.includes(data.langCode)) {
        let l = {
          langCode: data.langCode,
          langName: data.langName,
          checked: true,
          disabled: false
        };
        this.languageJSON[i] = l;
      }
    });
    this.checkCount();
    if (this.isPartnerContent && !this.isInEdit) {
      this.languageJSON.forEach((data) => {
        this.userPrtnerSelectedLang.set(data.langCode, data.langName);
      })
    }
  }
  updateLanguageList() {
    this.userSelectedLanguageName = [];
    this.newSelectedLanguage = [];

    if (!this.isPartnerContent) {
      this.checkChineseLanguages();
      this.languageJSON.forEach(element => {
        const index = this.userSelectedLanguage.findIndex(item => item === element.langCode);
        if (index >= 0) {
          element.checked = true;
          this.userSelectedLanguageName.push(element.langName);
          this.newSelectedLanguage.push(element.langCode);
        } else {
          element.checked = false;
        }
      });
      this.selectedLangvalues = {
        userSelectedLanguageName: this.userSelectedLanguageName,
        userSelectedLanguage: this.userSelectedLanguage
      };
    }

    else {
      this.selectedLangvalues = {
        userSelectedLanguageName: Array.from(this.userPrtnerSelectedLang.values()),
        userSelectedLanguage: Array.from(this.userPrtnerSelectedLang.keys()),
        allLang: this.userPrtnerSelectedLang.size === this.languageJSON.length
      }
      this.RecoverPrtnerSelectedLang = new Map(this.userPrtnerSelectedLang);
    }
    this.updateLanguage.emit(this.selectedLangvalues);
  }

  open() {
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.modalRef = this.modalService.open(this.modalContent, this.modalOption);
    this.modalRef.result.then();
  }

  close() {
    this.modalRef.close();
  }

  dismiss() {
    this.userPrtnerSelectedLang = new Map(this.RecoverPrtnerSelectedLang);
    this.userSelectedLanguage = [];
    this.newSelectedLanguage.forEach(element => {
      this.userSelectedLanguage.push(element);
    });
    this.checkCount();
    if (!this.isPartnerContent) {
      this.checkChineseLanguages();
    }
    this.modalRef.dismiss();
  }

  updateList(data, status) {
    const index = this.languageJSON.findIndex(each => each.langCode.toLowerCase() === data.toLowerCase());
    if (index >= 0) {
      this.languageJSON[index].checked = status;
      if (!this.userSelectedLanguage.includes(this.languageJSON[index].langCode)) {
        this.userSelectedLanguage.push(this.languageJSON[index].langCode);
        this.userSelectedLanguageName.push(this.languageJSON[index].langName);
      }
    }
    if (this.userSelectedLanguage.length > 4) {
      this.checkCount();
    }
  }

  updateListPartnerContent(data, status) {
    const index = this.languageJSON.findIndex(each => each.langCode.toLowerCase() === data.toLowerCase())

    if (index >= 0) {
      this.languageJSON[index].checked = status;
      this.userSelectedLanguage.push(this.languageJSON[index].langCode);
      this.userSelectedLanguageName.push(this.languageJSON[index].langName);
    }
  }

  getLanguageChkBx(data) {
    if (this.isPartnerContent) {
      if (this.userPrtnerSelectedLang.has(data.langCode)) {
        this.userPrtnerSelectedLang.delete(data.langCode);
      } else {
        this.userPrtnerSelectedLang.set(data.langCode, data.langName);
      }
      this.noSelection = !this.userPrtnerSelectedLang.size;
    }
    else {
      if (data.currentTarget.checked) {
        this.userSelectedLanguage.push(data.currentTarget.id);
      } else {
        this.userSelectedLanguage = this.userSelectedLanguage.filter(item => item !== data.currentTarget.id);
      }
      this.checkCount();
    }
  }

  checkCount() {
    this.languageJSON.forEach(element => {
      if (this.userSelectedLanguage.length > 4) {
        const index = this.userSelectedLanguage.findIndex(item => item === element.langCode);
        element.disabled = index >= 0 ? false : true;
      } else {
        element.disabled = false;
      }
    });
  }

  isAllSelected() {
    if (this.isPartnerContent) {
      if (this.userPrtnerSelectedLang.size === this.languageJSON.length - this.systemIdSelectedLang.length) {
        this.allLang = false;
        this.userPrtnerSelectedLang.clear();
      } else {
        this.allLang = true;
        this.languageJSON.forEach(data => {
          if (!this.systemIdSelectedLang.includes(data.langCode))
            this.userPrtnerSelectedLang.set(data.langCode, data.langName);
        });
      }
    }
    this.noSelection = !this.userPrtnerSelectedLang.size;
  }

  checkChineseLanguages() {
    LANGUAGE_MAPPINGS.forEach(element => {
      if (element.langCode === GlobalConstants.CHINESE_CN) {
        element.langCode = GlobalConstants.CHINESE_HANS;
      } else if (element.langCode === GlobalConstants.CHINESE_TW) {
        element.langCode = GlobalConstants.CHINESE_HANT;
      }
    });
  }
}

